export const supportLink = 'https://support.mezzobyness.com'
